import { ModalId } from '@heidi/schema/ml-scribe';

/** `seen_modals` id for banner dismiss. */
export const HEIDI_2_AWARENESS_BANNER_MODAL_ID =
  ModalId.T4_CUSTOM_AUDIENCE_HEIDI_2_OPT_IN_BANNER;
